import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef} from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { SelectBoxAccessor } from "./select-box-accessor";


@Component({
  selector: 'app-select-box',
  templateUrl: './select-box.component.html',
  styleUrls: ['./select-box.component.scss'],
  providers: [SelectBoxAccessor]
})

export class SelectBoxComponent implements OnInit, ControlValueAccessor {

  @Input() selectBoxName: string;
  @Input() placeholder: string;
  @Input() required: boolean = false;
  @Input() optionValue:string = "code";
  @Input() optionLabel:string = "name"
  @Input() showClear: boolean = true;
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  private _disabledOptions: any[];
    
  @Input() set disabledOptions(value: any[]) {
     this._disabledOptions = value;
     this.setDisableOption();
  }
  
  get disabledOptions(): any[] {
      return this._disabledOptions;
  }

  private innerValue: any = null;
  items: any[] = [];
  defaultValue: any = null;

  //by the Control Value Accessor
  private onTouchedCallback: () => void =  () => {};
  private onChangeCallback: (_: any) => void =  () => {};

  //get accessor
  get value(): any {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }


  constructor(private  changeDetector: ChangeDetectorRef) {  }


  ngOnInit(): void {
    if(this.selectBoxName) {
      const selectBoxItems = localStorage.getItem(this.selectBoxName);
      if(!selectBoxItems) return;
      this.items = JSON.parse(selectBoxItems);
      this.setDisableOption();
    }
  }

  ngAfterContentChecked(): void  {

    this.changeDetector.detectChanges();

}


  setDisableOption() {
    if(this.disabledOptions && this.disabledOptions.length > 0) {
      this.items.forEach(i => {
        if(this.disabledOptions.find(d => JSON.stringify(d) === JSON.stringify(i) )) i['disabled'] = true;
      })
    }
  }

}
